<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>My Journals</h1>
      <v-divider></v-divider>

      <div class="row">
        <div class="pl-3 col-6">
          <v-text-field
            id="search"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col-6"></div>
      </div>

      <div class="row">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Title</th>
                  <th class="text-left">ISSN</th>
                  <th class="text-left">Contributor</th>
                  <th class="text-left">Publisher</th>
                  <th class="text-left">End date</th>
                  <th style="width: 200px">Number borrowed / No of copies</th>
                  <th class="text-left">Detail</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.Title }}</td>
                  <td>{{ item.ISSN }}</td>
                  <td>{{ item.contributor1 }}</td>
                  <td>{{ item.PublisherName }}</td>
                  <td>{{ item.EndDate | formatDate }}</td>
                  <td>
                    <v-progress-linear
                      color="light-blue"
                      height="20"
                      v-model="item.percentage"
                      striped
                    >
                      <strong
                        >{{ item.NoOfLending }}/{{ item.NoOfCopies }}</strong
                      >
                    </v-progress-linear>
                  </td>
                  <td>
                    <v-icon
                      small
                      color="blue darken-2"
                      @click="showDialogDetail(item.id)"
                    >
                      mdi-domain
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>


    <v-dialog v-model="showDialog" width="800" height="600">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Journal Details
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="4">
                <v-img :src="selectedItem.ThumbnailPath" @error="ThumbnailPathNotFound"></v-img>
              </v-col>
              <v-col cols="8">
                <v-row>
                  <v-col>Title: {{ selectedItem.Title }}</v-col>
                </v-row>
                <v-row>
                  <v-col>ISSN: {{ selectedItem.ISSN }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">Content: {{ selectedItem.Content }}</v-col>
                  <v-col cols="6">Publisher: {{ selectedItem.Publisher }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">Frequency: {{ selectedItem.Frequency }}</v-col>
                  <v-col cols="6">Scope: {{ selectedItem.Scope }}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-divider></v-divider>
              </v-col>
            </v-row>
            
            <!--
            <v-row>
              <v-col>Summary: {{ selectedItem.Summary }}</v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">Keywords: {{ selectedItem.keywords }}</v-col>
              <v-col cols="4">List Price: {{  selectedItem.listprice }}</v-col>
              <v-col cols="4">Discount: {{ selectedItem.discount }}</v-col>
            </v-row>
            <v-row>
              <v-col>Countries Allowed: {{ selectedItem.countries_allowed }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="4">Bisac: {{ selectedItem.bisac  }}</v-col>
              <v-col cols="4">Lcc: {{ selectedItem.lcc }}</v-col>
              <v-col cols="4">Dewey: {{ selectedItem.dewey }}</v-col>
            </v-row>
            <v-row>
              <v-col>Language: {{ selectedItem.language }}</v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Contributor Role
                        </th>
                        <th class="text-left">
                          Contributor
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="(selectedItem.contributorRole1 != null && selectedItem.contributorRole1.length >0)
                        || (selectedItem.contributor1 != null && selectedItem.contributor1.length >0)">
                        <td>{{ selectedItem.contributorRole1 }}</td>
                        <td>{{ selectedItem.contributor1 }}</td>
                      </tr>
                      <tr v-if="(selectedItem.contributorRole2 != null && selectedItem.contributorRole2.length >0)
                        || (selectedItem.contributor2 != null && selectedItem.contributor2.length >0)">
                        <td>{{ selectedItem.contributorRole2 }}</td>
                        <td>{{ selectedItem.contributor2 }}</td>
                      </tr>
                      <tr v-if="(selectedItem.contributorRole3 != null && selectedItem.contributorRole3.length >0)
                        || (selectedItem.contributor3 != null && selectedItem.contributor3.length >0)">
                        <td>{{ selectedItem.contributorRole3 }}</td>
                        <td>{{ selectedItem.contributor3 }}</td>
                      </tr>
                      <tr v-if="(selectedItem.contributorRole4 != null && selectedItem.contributorRole4.length >0)
                        || (selectedItem.contributor4 != null && selectedItem.contributor4.length >0)">
                        <td>{{ selectedItem.contributorRole4 }}</td>
                        <td>{{ selectedItem.contributor4 }}</td>
                      </tr>
                      <tr v-if="(selectedItem.contributorRole5 != null && selectedItem.contributorRole5.length >0)
                        || (selectedItem.contributor5 != null && selectedItem.contributor5.length >0)">
                        <td>{{ selectedItem.contributorRole5 }}</td>
                        <td>{{ selectedItem.contributor5 }}</td>
                      </tr>
                      <tr v-if="(selectedItem.contributorRole6 != null && selectedItem.contributorRole6.length >0)
                        || (selectedItem.contributor6 != null && selectedItem.contributor6.length >0)">
                        <td>{{ selectedItem.contributorRole6 }}</td>
                        <td>{{ selectedItem.contributor6 }}</td>
                      </tr>
                      <tr v-if="(selectedItem.contributorRole7 != null && selectedItem.contributorRole7.length >0)
                        || (selectedItem.contributor7 != null && selectedItem.contributor7.length >0)">
                        <td>{{ selectedItem.contributorRole7 }}</td>
                        <td>{{ selectedItem.contributor7 }}</td>
                      </tr>
                      <tr v-if="(selectedItem.contributorRole8 != null && selectedItem.contributorRole8.length >0)
                        || (selectedItem.contributor8 != null && selectedItem.contributor8.length >0)">
                        <td>{{ selectedItem.contributorRole8 }}</td>
                        <td>{{ selectedItem.contributor8 }}</td>
                      </tr>
                      <tr v-if="(selectedItem.contributorRole9 != null && selectedItem.contributorRole9.length >0)
                        || (selectedItem.contributor9 != null && selectedItem.contributor9.length >0)">
                        <td>{{ selectedItem.contributorRole9 }}</td>
                        <td>{{ selectedItem.contributor9 }}</td>
                      </tr>
                      <tr v-if="(selectedItem.contributorRole10 != null && selectedItem.contributorRole10.length >0)
                        || (selectedItem.contributor10 != null && selectedItem.contributor10.length >0)">
                        <td>{{ selectedItem.contributorRole10 }}</td>
                        <td>{{ selectedItem.contributor10 }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
            -->
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import * as api from "@/api";
import Pagination from "@/components/Pagination";
export default {
  name: "OrgMyPublications",
  components: {
    Pagination
  },
  created() {
    this.getJournalByPagin();
    //this.getContents();
  },
  methods: {
    percentage(item) {
      return Math.round((100 * item.NoOfLending) / item.NoOfCopies);
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getJournalByPagin();
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getJournalByPagin();
    },
    getJournalByPagin() {
      let that = this;
      this.list = [];
      that.overlay = true;
      new Promise((resolve, reject) => {
        api
          .getByPagin("purchase-order/journal", this.paging)
          .then(response => {
            console.log(response.data.data);
            this.paging.count = response.data.count;
            this.list = response.data.data;
            that.overlay = false;
          })
          .catch(error => {
            reject(error);
            that.overlay = false;
          });
      });
    },

    getContents() {
      //this.list = [];
      console.log("getContents");
      new Promise((resolve, reject) => {
        api
          .getByID(
            "licenses/download/contents",
            "0b8483ac-35e1-49b0-9d52-5a169cd0b517"
          )
          .then(response => {
            console.log(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    showDialogDetail(id) {
      console.log("Show Dialog Id " + id);
      this.selectedItem = this.list.filter(i => i.id == id)[0];
      console.log(this.selectedItem);
      this.showDialog = true;
    },
    ThumbnailPathNotFound() {
      this.selectedItem.ThumbnailPath = "https://placehold.co/60x40?text=" + "ISBN:" + this.selectedItem.ISBN
    }
  },
  data() {
    return {
      paging: { count: 20, page: 1, size: 20, keyword: "" },
      list: [],
      Search: "",
      overlay: false,
      showDialog: false,
      selectedItem: {}
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/views/organization/OrgViewMyJournals.vue